import React from "react";

import { observer } from "mobx-react-lite";
import BookingStore from "booking/store/BookingStore";
import { StepIntoActionBookingData } from "common";
import { Formik, Field } from "formik";
import * as yup from "yup";
import { InputYesNo } from "core/components/generic/InputYesNo";
import SubmitBookingUseCase from "booking/use-cases/SubmitBookingUseCase";

const StepIntoActionInformation = observer(() => {
    const store = BookingStore.get();
    const bookingData = store.bookingData as StepIntoActionBookingData;

    const onSubmit = async (values: Partial<StepIntoActionBookingData>) => {
        await SubmitBookingUseCase.create().execute({ ...bookingData, ...values });
    };

    return (
        <Formik
            initialValues={{
                testConsent: bookingData.testConsent,
            }}
            onSubmit={onSubmit}
            validationSchema={yup.object({
                testConsent: yup
                    .bool()
                    .oneOf([true], "You must agree to proceed")
                    .required("Please choose Yes or No"),
            })}
            validateOnChange={true}
        >
            {({ submitForm, setFieldValue, isSubmitting, errors }) => {
                return (
                    <form onSubmit={(e) => e.preventDefault()} className="l-app +y +gap-0">
                        <div className="l-app__item +middle">
                            <div className="u-height-100pc u-pad">
                                <div className="u-flex u-align-items-center u-justify-content-center">
                                    <div className="o-wrap u-width-login">
                                        <div className="u-border u-rounded u-fill-white u-shadow-ambient">
                                            <div className="u-pad-large">
                                                <p className="u-font-bold u-font-xxl u-marg-bottom">
                                                    Step Into Action questions
                                                </p>
                                                <div
                                                    className={`c-field u-marg-bottom ${
                                                        errors.testConsent ? "+error" : ""
                                                    }`}
                                                >
                                                    <p className="u-font-bold u-font-l u-marg-bottom">
                                                        How we use your information:
                                                    </p>
                                                    <p className="u-marg-bottom">
                                                        Sometimes we use/share anonymised data with
                                                        trusted third parties such as
                                                        <span className="u-font-bold">
                                                            universities or funders
                                                        </span>{" "}
                                                        for service audit and evaluation purposes.
                                                        This helps us demonstrate the value of our
                                                        work and contribute to wider learning.{" "}
                                                        <span className="u-font-bold">
                                                            We never share your personal
                                                            information.
                                                        </span>
                                                    </p>
                                                    <Field
                                                        name="testConsent"
                                                        component={InputYesNo}
                                                        label="I understand how AC will process my information."
                                                        onChange={(e) =>
                                                            setFieldValue(
                                                                "testConsent",
                                                                e.target.value === "true"
                                                            )
                                                        }
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="l-app__item +end">
                            <div className="u-pad u-fill-white u-border-top">
                                <div className="u-flex c-footer">
                                    <button
                                        type="button"
                                        className="c-button +quiet u-marg-right u-marg-bottom-small"
                                        onClick={() => {
                                            store.setEnteringPersonalDetails(true);
                                        }}
                                    >
                                        <svg className="c-icon u-font-xl u-marg-right-small">
                                            <use href="/symbol-defs.svg#icon-arrow-left" />
                                        </svg>
                                        Back
                                    </button>

                                    <button
                                        type="submit"
                                        className="c-button u-fill-1 +primary u-marg-bottom-small"
                                        onClick={submitForm}
                                        disabled={isSubmitting}
                                    >
                                        Book Appointment
                                        <svg className="c-icon u-font-xl u-marg-left-small">
                                            <use href="/symbol-defs.svg#icon-check" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                );
            }}
        </Formik>
    );
});

export default StepIntoActionInformation;
